import * as React from 'react';
import { SVGProps } from 'react';

const IconMapFilledSizeL = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 28 28" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M7.5 5.934a.5.5 0 0 0-.777-.416L3.445 7.703A1 1 0 0 0 3 8.535v14.53a.5.5 0 0 0 .777.417l3.278-2.185a1 1 0 0 0 .445-.832V5.935ZM11.129 20.852a1 1 0 0 1-.629-.929V5.339a.5.5 0 0 1 .686-.465L16.87 7.15a1 1 0 0 1 .629.928v14.585a.5.5 0 0 1-.686.464l-5.685-2.274ZM20.5 22.441a.5.5 0 0 0 .724.447l3.223-1.612a1 1 0 0 0 .553-.894V4.934a.5.5 0 0 0-.777-.416l-3.278 2.185a1 1 0 0 0-.445.832v14.906Z" />
  </svg>
);
export default IconMapFilledSizeL;
